import { DataConfigurations } from "@/types";

export const getDefaultColumnChoices = (
  dataConfigurations: DataConfigurations | null,
) => {
  return (
    dataConfigurations?.column_choices?.reduce(
      (acc, choice) => {
        if (choice.default) {
          acc[choice.key] = choice.default;
        }
        return acc;
      },
      {} as { [key: string]: string[] },
    ) ?? {}
  );
};
